import type { ResolverMap } from './ResolverMap'
import type { ResultCode } from './ResultCode'

const resultCodeByCode = {
  PASSWORD_RESET_LINK_SENT: 'presentation.results.passwordResetLinkSent',
  PASSWORD_RESET_COMPLETED: 'presentation.results.passwordResetCompleted',
  PHONE_VERIFIED: 'presentation.results.phoneVerified',
  PHONE_VERIFICATION_SENT: 'presentation.results.phoneVerificationSent',
  PHONE_VERIFICATION_NOT_REQUIRED: 'presentation.results.phoneVerificationNotRequired',
  REGISTRATION_COMPLETED: 'presentation.results.registrationCompleted',
  EMAIL_VERIFIED: 'presentation.results.emailVerified',
  EMAIL_VERIFICATION_SENT: 'presentation.results.emailVerificationSent',
  FAVORITE_STORE_TOGGLED: 'presentation.results.favoriteStoreToggled',
  FAVORITE_STORES_SYNCED: 'presentation.results.favoriteStoresSynced',
  SUPPORT_REQUEST_SUBMITTED: 'presentation.results.supportRequestSubmitted',
  REVIEW_SUBMITTED: 'presentation.results.reviewSubmitted',
  CONTACT_MESSAGE_SUBMITTED: 'presentation.results.contactMessageSubmitted',
  LEAD_SUBMITTED: 'presentation.results.leadSubmitted',
  PARTNER_UPDATED: 'presentation.results.partnerUpdated',
  PARTNER_DEACTIVATED: 'presentation.results.partnerDeactivated',
  ORDER_MODIFICATION_APPROVED: 'presentation.results.orderModificationApproved',
  ORDER_MODIFICATION_REJECTED: 'presentation.results.orderModificationRejected',
  PROFILE_UPDATED: 'presentation.results.profileUpdated',
  AVATAR_UPLOADED: 'presentation.results.avatarUploaded',
  AVATAR_DELETED: 'presentation.results.avatarDeleted',
  INVITATION_SENT: 'presentation.results.invitationSent',
  INVITATION_ACCEPTED: 'presentation.results.invitationAccepted',
  INVITATION_RESENT: 'presentation.results.invitationResent',
  INVITATION_CANCELLED: 'presentation.results.invitationCancelled',
  INVITATION_DELETED: 'presentation.results.invitationDeleted',
  REVIEW_UPDATED: 'presentation.results.reviewUpdated',
  REVIEW_MARKED_HELPFUL: 'presentation.results.reviewMarkedHelpful',
  RESOURCE_DELETED: 'presentation.results.resourceDeleted',
  WEBHOOK_ACKNOWLEDGED: 'presentation.results.webhookAcknowledged',
  DASHBOARD_ENTITY_ACTION_COMPLETED: 'presentation.results.dashboardEntityActionCompleted',
  REGISTRATION_STEP_VALIDATED: 'presentation.results.registrationStepValidated',
  REVIEW_HELPFUL_MARK_REMOVED: 'presentation.results.reviewHelpfulMarkRemoved',
  CART_ITEM_MERGED: 'presentation.results.cartItemMerged',
  CART_ITEM_UPDATED: 'presentation.results.cartItemUpdated',
  CHECKOUT_COMPLETED: 'presentation.results.checkoutCompleted',
  NOTIFICATION_INBOX_MARKED_READ: 'presentation.results.notificationInboxMarkedRead',
  NOTIFICATION_INBOX_CLEARED: 'presentation.results.notificationInboxCleared',
  ORDER_CANCELLED: 'presentation.results.orderCancelled',
  ORDER_MODIFICATION_REQUESTED: 'presentation.results.orderModificationRequested',
  ORDER_MODIFICATION_APPLIED: 'presentation.results.orderModificationApplied',
  ORDER_PAYMENT_SUBMITTED: 'presentation.results.orderPaymentSubmitted',
  ORDER_STATUS_TRANSITION_SUPPRESSED: 'presentation.results.orderStatusTransitionSuppressed',
  LEGAL_AGREEMENT_EMAILED: 'presentation.results.legalAgreementEmailed',
  LOGGED_OUT: 'presentation.results.loggedOut',
  OTHER_SESSIONS_LOGGED_OUT: 'presentation.results.otherSessionsLoggedOut',
  RESOURCE_CREATED: 'presentation.results.resourceCreated',
  RESOURCE_UPDATED: 'presentation.results.resourceUpdated',
  RESOURCE_RETRIEVED: 'presentation.results.resourceRetrieved',
  LOGGED_IN: 'presentation.results.loggedIn',
  TWO_FACTOR_CHALLENGE_ISSUED: 'presentation.results.twoFactorChallengeIssued',
  TWO_FACTOR_STEP_UP_CONFIRMED: 'presentation.results.twoFactorStepUpConfirmed',
  PASSWORD_UPDATED: 'presentation.results.passwordUpdated',
  PASSWORD_CONFIRMED: 'presentation.results.passwordConfirmed',
  TWO_FACTOR_ENABLED: 'presentation.results.twoFactorEnabled',
  TWO_FACTOR_DISABLED: 'presentation.results.twoFactorDisabled',
  TWO_FACTOR_CONFIRMED: 'presentation.results.twoFactorConfirmed',
  TWO_FACTOR_RECOVERY_CODES_REGENERATED: 'presentation.results.twoFactorRecoveryCodesRegenerated',
  TWO_FACTOR_RECOVERY_CODES_RETRIEVED: 'presentation.results.twoFactorRecoveryCodesRetrieved',
  TWO_FACTOR_QR_CODE_RETRIEVED: 'presentation.results.twoFactorQrCodeRetrieved',
  TWO_FACTOR_SECRET_KEY_RETRIEVED: 'presentation.results.twoFactorSecretKeyRetrieved'
} satisfies Record<ResultCode, string>

export const resultCodeResolverMap: ResolverMap<ResultCode> = {
  byCode: resultCodeByCode,
  byReason: {},
  genericKey: 'presentation.results.genericCompleted'
}
